import React, { useState } from 'react'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import PropTypes from "prop-types";
import { Dropdown } from 'semantic-ui-react';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import './style.css'
import { isMobileOnly} from 'mobile-device-detect'
import {MonthYearPicker} from "./MonthYearPicker";
import { dateFormat } from '../constants';

export const DatePicker = ({onChange, value, type, ...rest})=>{

    const onDateChange = (e, {value})=>{
        if (e && onChange){
            onChange(value)
        }
    }

    return type === "month"? <MonthYearPicker onChange={onChange} {...rest}/>: <SemanticDatepicker
        format={rest.format || dateFormat}
        onChange={onDateChange}
        value={value}
        autoComplete="off"
        datePickerOnly={isMobileOnly}
        type={type}
        locale={document.documentElement.lang || 'he-IL'}
        {...rest}
    />
}
DatePicker.propTypes = {
    type: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date),  PropTypes.arrayOf(PropTypes.instanceOf(Date))])
}

export const TimePicker = ({onChange, value ,step, clearable, ...rest})=>{
    const defaultStep = 15
    const s = step || defaultStep
    const range = moment.range('2000-01-01', '2000-01-02');
    const [acc, setAcc] = useState(Array.from(range.by('minute', { excludeEnd: true, step: s })))

    const onTimeChange = (e, {value})=>{
        if (onChange){
            onChange(value)
        }
    }

    const dateFormat = "HH:mm"
    const round = val=>{
        const rem = val.minute() % s;
        return rem?val.add(s-rem, "minutes"):val
    }
    const renderOptions = ()=>{
        const options = []
        if (clearable){
            options.push( {
                text: "None", 
                value: undefined,
                key: "none"
            })
        }
        return [...options, ...acc.map(val=>{
            return {
                text: val.format(dateFormat), 
                value: val.format(dateFormat),
                key: val.format(dateFormat)
            }})
        ]
    }

    return <Dropdown 
    onChange={onTimeChange} 
    search={false} allowAdditions={false} selection icon={{name: "time", link: true}} className='timepicker input icon' 
    options={renderOptions()} 
    onAddItem={(e, {value})=>setAcc([moment(value, dateFormat), ...acc])} 
    value={round(moment(value, moment.HTML5_FMT.TIME_SECONDS)).format(dateFormat)} {...rest}/>
}
 
TimePicker.propTypes = {
    step: PropTypes.number,
    onChange: PropTypes.func,
    value:PropTypes.string,
    clearable: PropTypes.bool,
}
